var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpracheUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Sprache-UK__Icn/40px/Sprache-UK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Sprache-UK__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Sprache-UK__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2450195,25 L17.2450195,23.062 L11.1080195,23.062 L11.1080195,19.798 L16.6330195,19.798 L16.6330195,17.86 L11.1080195,17.86 L11.1080195,14.902 L16.9390195,14.902 L16.9390195,12.964 L8.96601953,12.964 L8.96601953,25 L17.2450195,25 Z M21.9816233,25 L21.9816233,15.769 L22.0133334,15.769 L27.5626018,25 L30.0994102,25 L30.0994102,12.964 L28.1016736,12.964 L28.1016736,21.906 L28.0699634,21.906 L22.6316805,12.964 L19.9838867,12.964 L19.9838867,25 L21.9816233,25 Z",
    id: ".._.._src_svg_Icn_40px_Sprache-UK__EN"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpracheUk);
export default __webpack_public_path__ + "static/media/Sprache-UK.819cdd0f83196299bb580540acc945f3.svg";
export { ForwardRef as ReactComponent };